"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconClip = function SvgIconClip(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "clip icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Clip Icon'), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "nonzero",
    d: "M31.272 13.09V34a7.273 7.273 0 01-14.545 0V11.273a4.545 4.545 0 119.09 0v19.09a1.818 1.818 0 11-3.636 0V13.091h-2.727v17.272a4.545 4.545 0 109.09 0v-19.09a7.273 7.273 0 00-14.545 0V34c0 5.523 4.479 10 10 10 5.522 0 10-4.477 10-10V13.09h-2.727z"
  }));
};

var _default = SvgIconClip;
exports.default = _default;